import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import {
  Link,
  Breadcrumbs,
  Typography
} from '@material-ui/core';

const BreadCrumb = (props) => {

  if(!props.items || props.items.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {props.items.map((item, index) => {
        if(index+1 === props.items.length) {
          return <Typography color="textPrimary" key={item.name}>{item.name}</Typography>
        } else {
          return <Link component={RouterLink} to={item.link} key={item.name}>{item.name}</Link>
        }
      })}
    </Breadcrumbs>
  );

};

BreadCrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
};

export default BreadCrumb;
